import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../shared/services/base.service';
import { environment } from 'src/environments/environment';

export interface SearchResult {
    id: number;
    entity: string;
    term: string;
    display: string;
    related_entity: string;
    related_entity_id: number;
    related_term: string;
    related_entity_icon: string;
}

/**
 * Service for global search functionality
 * Provides search operations across multiple entity types
 */
@Injectable({
    providedIn: 'root'
})
export class SearchService extends BaseService<SearchResult> {

    /**
     * Search across all entities
     * @param term The search term
     * @returns Observable with search results
     */
    search(term: string): Observable<SearchResult[]> {
        return this.http.get<SearchResult[]>(`${environment.config.api_url}search`, {
            params: { term }
        });
    }
}
